import ApiService from '@/common/ApiService/ApiService';
import SelectItem from '@/common/interfaces/SelectItem';
import { isSSR } from '@/utils/commonUtils';

const apiService = new ApiService('/api/AddressValidatorApiService', {
  returnData: true,
  cancel: true,
  showLoading: false,
});

export interface CountryData {
  Value: string | number;
  Text: string;
  PhoneCode: string;
  ISO: string;
  Alpha2: string;
  IsForBrochures: boolean;
}

export interface CountryState {
  CountryId: number;
  States: string[];
}

export interface CountryFullData {
  Countries: CountryData[];
  States: CountryState[];
}

export const getCountriesList = async (): Promise<SelectItem[]> =>
  await apiService.call('GetCountriesList');

export const getFullCountryData = async (): Promise<CountryFullData> =>
  await apiService.call('GetFullCountryData').then((data) => {
    FixCountryJson(data);

    return data;
  });

function FixCountryJson(data: any) {
  data.Countries = data.Countries.map((s: any) => ({
    Text: s.t,
    Value: s.v,
    PhoneCode: s.p,
    ISO: s.i,
    Alpha2: s.a,
    IsForBrochures: s.b,
  }));

  return data;
}

class CountryDictionaries {
  private _fullDataPromise: Promise<CountryFullData> | undefined = undefined;

  private get fullDataPromise() {
    if (!this._fullDataPromise) {
      this._fullDataPromise = getFullCountryData();
    }

    return this._fullDataPromise;
  }

  getFullData() {
    return this.fullDataPromise;
  }
}

export const countryDictionaries = new CountryDictionaries();

let data: CountryFullData;
export function getCountryData() {
  if (!data) {
    throw Error(
      'Country data is not loaded. Are you run "await InitCountries();" from "src/api/CountryStateApi.ts" in .store.ts registerModule()?',
    );
  }
  return data;
}

export const InitCountries = async () => {
  const minifiedData = require('./countries.json');
  data = (FixCountryJson(minifiedData) as any) as CountryFullData;
  return data;
  if (!data) {
    if (isSSR()) {
      setTestData();
      return;
    }

    const d = localStorage.getItem('CountriesInfo');

    if (d) {
      const fromStorage = JSON.parse(d) as {
        timestamp: number;
        value: CountryFullData;
      };

      const expireMilliseconds = 3 * 24 * 3600 * 1000; // 3 days
      if (
        fromStorage &&
        fromStorage.timestamp &&
        fromStorage.timestamp + expireMilliseconds > +new Date()
      ) {
        data = fromStorage.value;
      }
    }

    if (!data) {
      data = await countryDictionaries.getFullData();
      localStorage.setItem(
        'CountriesInfo',
        JSON.stringify({
          timestamp: +new Date(),
          value: data,
        }),
      );
    }
  }
};

export async function setTestData() {
  if (!data) {
    const minifiedData = await import('./countries.json');

    data = (FixCountryJson(minifiedData.default) as any) as CountryFullData;

    if (!isSSR()) {
      localStorage.setItem(
        'CountriesInfo',
        JSON.stringify({
          timestamp: +new Date(),
          value: data,
        }),
      );
    }
  }
}
